import React from "react";

const Bash_Mv = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Mv</h2>
      <p>Move or rename files.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>mv [options] source dest</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>mv oldname.txt newname.txt
mv file.txt /tmp/</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use with care; moving across filesystems does copy+remove.</p>
    </div>
  );
};

export default Bash_Mv;
